import {
  Flex,
  type FlexProps,
  Heading,
  List,
  ListIcon,
  ListItem,
  Text,
  type TextProps,
} from '@/ui';

const Paint = (props: TextProps) => (
  <Text as="span" {...props}>
    🎨
  </Text>
);

export const Benefits = (props: FlexProps) => {
  return (
    <Flex direction="column" gap="6" {...props}>
      <Heading as="h3" fontSize="lg" fontWeight="bold">
        Connect your Canva account for an even better experience!
      </Heading>

      <List display="flex" flexDir="column" fontWeight="medium" gap="3">
        <ListItem alignItems="center" display="flex">
          <ListIcon as={Paint} />
          <Text>Create pages from Canva designs</Text>
        </ListItem>
      </List>
    </Flex>
  );
};
